import { IconButton } from "@fluentui/react";

function DefaultContextualMenu({
    editOnClick,
    deleteOnClick,
    cloneOnClick,
    moveUpOnClick,
    moveDownOnClick,
    newRevisionOnClick,
    ...rest
}) {
    const items = [];

    if (editOnClick) {
        items.push({
            key: "edit",
            iconProps: { iconName: "Edit" },
            text: "Edit",
            onClick: editOnClick,
        });
    }

    if (deleteOnClick) {
        items.push({
            key: "delete",
            iconProps: { iconName: "Delete" },
            text: "Delete",
            onClick: deleteOnClick,
        });
    }

    if (cloneOnClick) {
        items.push({
            key: "clone",
            iconProps: { iconName: "Copy" },
            text: "Clone",
            onClick: cloneOnClick,
        });
    }

    if (moveUpOnClick) {
        items.push({
            key: "moveUp",
            iconProps: { iconName: "ChevronUp" },
            text: "Move Up",
            onClick: moveUpOnClick,
        });
    }

    if (moveDownOnClick) {
        items.push({
            key: "moveDown",
            iconProps: { iconName: "ChevronDown" },
            text: "Move Down",
            onClick: moveDownOnClick,
        });
    }

    if (newRevisionOnClick) {
        items.push({
            key: "newRevision",
            iconProps: { iconName: "DoubleColumnEdit" },
            text: "New Revision",
            onClick: newRevisionOnClick,
        });
    }

    const menuProps = { items: items };

    return <IconButton iconProps={{ iconName: "More" }} menuProps={menuProps} onRenderMenuIcon={() => {}} {...rest} />;
}

export default DefaultContextualMenu;
